import Vue from 'vue';
import App from './App.vue';

import ServerError from './components/ServerError.vue';
import DynamicIcon from './components/shared/DynamicIcon.vue';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import ToggleSwitch from './components/shared/ToggleSwitch.vue';
import FileUploadWidget from './components/widgets/FileUploadWidget.vue';
import Tooltip from './components/shared/Tooltip.vue';

import VueJwtDecode from 'vue-jwt-decode';

/* Directives */
import tooltipDirective from './directives/tooltip.directive';

/* Filters */

import dateFormatted from './filters/dateFormatted.filter';

/* Import Plugins */
import {
  router
} from './plugins/vue-router';
import {
  i18n
} from './plugins/vue-i18n';
import './plugins/vue-jwt-decode';
import loadingPlugin from './plugins/loading';
import fileLoadingPlugin from './plugins/fileLoading';
import eventRegistryPlugin from './plugins/eventRegistry';
import paymentCalculationPlugin from './plugins/paymentCalculations';
import currencyRatePlugin from './plugins/currencyRate';
import assetComponentsPlugin from './plugins/assetComponent';
import discountRatesPlugin from './plugins/discountRates';
import indexationPlugin from './plugins/indexation';
import reportsPlugin from './plugins/reports';
import contractsFilterPlugin from './plugins/contracts';
import paymentPlugin from './plugins/payment';


// Plugins npm
import './assets/scss/styles.scss';
import 'vue-search-select/dist/VueSearchSelect.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VModal from 'vue-js-modal';
import 'vue2-datepicker/locale/ru';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import moment from 'moment';
import Checkbox from 'vue-material-checkbox';
import {
  ModelListSelect
} from 'vue-search-select';

/* Import Vuex Store */
import {
  store
} from './store';
import ConfirmationModal from './components/shared/ConfirmationModal';
import InputNumberCustom from "@/components/shared/InputNumberCustom.vue";

Vue.component('tooltip', Tooltip);

Vue.component('server-error', ServerError);

Vue.component('dynamic-icon', DynamicIcon);

Vue.component('datepicker', DatePicker);

Vue.component('checkbox', Checkbox);

Vue.component('cool-select', ModelListSelect);

Vue.component('numeric', InputNumberCustom);

Vue.component('toggle-switch', ToggleSwitch);

Vue.component('file-upload', FileUploadWidget);

Vue.component('confirmation-modal', ConfirmationModal);

Vue.use(tooltipDirective);

Vue.use(dateFormatted);

Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true,
  position: "bottom-right",
  timeout: 5000,
  closeOnClick: true,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: "button",
  icon: true,
  rtl: false
});

Vue.use(VModal, {
  componentName: 'popup'
});

Vue.use(loadingPlugin, {
  store,
});

Vue.use(fileLoadingPlugin, {
  store,
});

Vue.use(eventRegistryPlugin, {
  store,
});

Vue.use(paymentCalculationPlugin, {
  store
});

Vue.use(currencyRatePlugin, {
  store
});

Vue.use(assetComponentsPlugin, {
  store
});

Vue.use(discountRatesPlugin, {
  store
});

Vue.use(indexationPlugin, {
  store
});

Vue.use(reportsPlugin, {
  store
});

Vue.use(contractsFilterPlugin, {
  store
});

Vue.use(paymentPlugin, {
  store
});

Vue.prototype.$moment = moment;

Vue.prototype.$eventBus = new Vue();

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
